import AdhdAssessmentResult from 'Pages/ADHDAssessmentResult';
import ADHDEmail from 'Pages/ADHDEmail';
import ADHDSelfTest from 'Pages/ADHDSelfTest';
import AnxietySelfTest from 'Pages/AnxietySelfTest';
import ADHDAssessment from 'Pages/ADHDAssessment';
import AnxietyAssessment from 'Pages/AnxietyAssessment';
import AnxietyEmail from 'Pages/AnxietyEmail';
import AnxietyAssessmentResult from 'Pages/AnxietyAssessmentResult';
import DepressionSelfTest from 'Pages/DepressionSelfTest';
import DepressionAssessment from 'Pages/DepressionAssessment';
import DepressionEmail from 'Pages/DepressionEmail';
import DepressionAssessmentResult from 'Pages/DepressionAssessmentResult';
import BipolarSelfTest from 'Pages/BipolarSelfTest';
import BipolarAssessment from 'Pages/BipolarAssessment';
import BipolarEmail from 'Pages/BipolarEmail';
import BipolarAssessmentResult from 'Pages/BipolarAssessmentResult';

const routes = [
  {
    path: '/adhd-self-test',
    component: ADHDSelfTest
  },
  {
    path: '/anxiety-self-test',
    component: AnxietySelfTest
  },
  {
    path: '/depression-self-test',
    component: DepressionSelfTest,
    isGradientBackground: true
  },
  {
    path: '/adhd-assessment',
    component: ADHDAssessment
  },
  {
    path: '/anxiety-assessment',
    component: AnxietyAssessment
  },
  {
    path: '/depression-assessment',
    component: DepressionAssessment
  },
  {
    path: '/depression-assessment-email',
    component: DepressionEmail
  },
  {
    path: '/depression-assessment-result',
    component: DepressionAssessmentResult
  },
  {
    path: '/adhd-assessment-result',
    component: AdhdAssessmentResult
  },
  {
    path: '/adhd-assessment-email',
    component: ADHDEmail
  },
  {
    path: '/anxiety-assessment-email',
    component: AnxietyEmail
  },
  {
    path: '/anxiety-assessment-result',
    component: AnxietyAssessmentResult
  },
  {
    path: '/bipolar-self-test',
    component: BipolarSelfTest,
    isGradientBackground: true
  },
  {
    path: '/bipolar-assessment',
    component: BipolarAssessment
  },
  {
    path: '/bipolar-assessment-email',
    component: BipolarEmail
  },
  {
    path: '/bipolar-assessment-result',
    component: BipolarAssessmentResult
  }
];

export default routes;
